import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

// AA-32: ya no se puede leer el JWT desde JS (cookie httpOnly) -- isLoggedIn() es solo una señal
// optimista basada en el último login/refresh exitoso, para evitar parpadeo de UI. La autorización
// real la impone el backend en cada request vía la cookie; si expiró, el interceptor cierra la
// sesión y redirige (ver jwt.interceptor.ts).
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (auth.isLoggedIn()) return true;
  router.navigate(['/login']);
  return false;
};
